// extracted by mini-css-extract-plugin
export var actionText = "_p7-4";
export var container = "_p7-0";
export var leftSection = "_p7-1";
export var rightSection = "_p7-2";
export var settingsButton = "_p7-6";
export var settingsIcon = "_p7-7";
export var shortcut = "_p7-5";
export var shortcutGroup = "_p7-3";